"use client";

import React from "react";
import idea_development_stock_image from "@/assets/img/idea development stock image.jpg"
import Image from "next/image";
import square_shape_bottom from "@/assets/img/bg/square-shape-bottom.png";


import {content_type, default as ContentBlock } from "./ContentBlock"

const idea_development_content: content_type[] = [
      {
        title: "What is idea development?",

        content: [
            "Crystalising your thoughts and messaging requires a deep dive, whether it’s for speaking engagements, board meetings, or books.",
            "Here’s where I come in: I will collaborate with you to land on your positioning and narrative so you’re clear on how to organise your thoughts and nail your delivery.",
        ],
      },
      {
        title: "What’s the process like for idea development?",
        content: [
            "Through a series of interviews, I’ll explore your ideas and expertly facilitate them into something coherent, with reassurance, confidence, and curiosity.",
            "Previous clients have called it a therapeutic experience that shifts their thinking from simply ‘writing a book’ to ‘articulating my deepest thoughts so they make simple sense, not just to others, but to me.’",
        ],
      },
      {
        
        content: [
            <p>Every project is slightly different, but <b>here’s an example of what a book idea development package looks like:</b></p>,

            <ul>
              <li><b>Stage 1</b>: Initial strategy calls and interviews, market analysis, positioning, and book outline (can include two rounds of revision).</li>
              <ul>
                  <li>Deliverables include:</li>
                  <ul>
                    <li>a full book outline that clearly states the primary audience</li>
                    <li>the central argument</li>
                    <li>comparable titles within this space</li>
                    <li>working titles for each chapter</li>
                    <li>bullet point summaries of what each chapter addresses</li>
                  </ul>
                  <li>Payment due before start of project</li>
              </ul>
              <li><b>Stage 2</b>: Media kit and pitching advice</li>
              <ul>
                <li>Deliverables include: </li>
                <ul>
                  <li>a completed media kit</li>  
                  <li>advice on how to grow your audience and presence</li>
                  <li>advice on how to pitch to agents/publishers</li>
                </ul>
              </ul>
            </ul>,
        ]  ,
        imageRight: idea_development_stock_image,
        image_alt_text: "Index cards organised on a table"
        
      },
      {
        title: "How much does it cost?",
        content: [
          "This service is highly bespoke and is tailored to you and your specific goals. As a rough baseline, previous book idea development projects have started from around £5,000 ($6,800) and go up from there.",
          "Get in touch to learn more about how this service could benefit you and your business goals."
        ]
    },
    
]

const IdeaDevelopmentContentBlock = () => {
  return (
    <section className="pb-20 pt-40 p-relative overlay-bg">
        <ContentBlock content={idea_development_content}/>
        <div className="ab-hero__shape-2">
            <Image src={square_shape_bottom} alt="image-here" />
        </div>
    </section>
  );
};

export default IdeaDevelopmentContentBlock;
